import Sale from '@/models/Sale'
import User, { hasRole, Role } from '@/models/User'

export default class SalePolicy {
    viewAny(user: User) {
        return hasRole(user, [Role.USER, Role.BROKER])
    }

    view(user: User, sale: Sale) {
        switch (user.role) {
            case Role.USER:
                return sale.company.id === user.company?.id
            case Role.BROKER:
                return true
            default:
                return false
        }
    }

    create(user: User) {
        return hasRole(user, Role.BROKER)
    }

    update(user: User, sale: Sale) {
        return hasRole(user, Role.BROKER) && sale.broker.id === user.broker?.id && !sale.closed_at && !sale.suspended_at && !sale.is_accepted
    }

    restore(user: User, sale: Sale) {
        return hasRole(user, Role.BROKER) && sale.broker.id === user.broker?.id && !sale.closed_at && !sale.suspended_at && !sale.is_accepted
    }

    delete(user: User, sale: Sale) {
        return hasRole(user, Role.BROKER) && sale.broker.id === user.broker?.id && !sale.closed_at && !sale.suspended_at && !sale.is_accepted
    }

    forceDelete(_user: User, _sale: Sale) {
        return false
    }
}
